import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Smartphone } from "lucide-react";
import { Logo } from "../components/Logo";
import { StoreButtons } from "../components/StoreButtons";

export default function ReviewReturnPage() {
    const [params] = useSearchParams();
    const raw = params.get("status");
    // Contrat C : seuls success|cancelled sont autorisés ; toute autre valeur = cancelled
    const status = raw === "success" ? "success" : "cancelled";
    const appLink = `frontend://review-return?status=${status}`;

    return (
        <main className="min-h-screen bg-ivory flex items-center justify-center p-6 relative overflow-hidden" data-testid="review-return-page">
            <div className="absolute -top-40 -right-40 w-[30rem] h-[30rem] rounded-full bg-gold/15 blur-3xl" aria-hidden="true" />
            <div className="w-full max-w-md relative z-10 text-center">
                <div className="flex justify-center mb-8"><Logo /></div>
                <div className="card-light p-10">
                    {status === "success" ? (
                        <>
                            <CheckCircle2 size={44} className="text-forest mx-auto" />
                            <h1 className="font-heading font-extrabold text-ink text-2xl mt-5">Merci pour votre témoignage</h1>
                            <p className="text-ink-soft mt-3 text-sm leading-relaxed">
                                Il a bien été enregistré et sera examiné par notre équipe avant publication.
                            </p>
                        </>
                    ) : (
                        <>
                            <XCircle size={44} className="text-gold-dark mx-auto" />
                            <h1 className="font-heading font-extrabold text-ink text-2xl mt-5">Témoignage non envoyé</h1>
                            <p className="text-ink-soft mt-3 text-sm leading-relaxed">
                                Aucun avis n'a été enregistré. Vous pouvez repartir de l'application quand vous le souhaitez.
                            </p>
                        </>
                    )}
                    <a
                        href={appLink}
                        className="mt-8 flex items-center justify-center gap-2 w-full bg-forest text-ivory rounded-2xl py-4 font-semibold hover:bg-forest-surface transition-colors"
                        data-testid="open-app-button"
                    >
                        <Smartphone size={18} /> Ouvrir l'application BODYCOACHIA
                    </a>
                    <p className="text-xs text-ink-soft mt-4">L'application n'est pas installée ?</p>
                    <div className="mt-3 flex justify-center">
                        <StoreButtons />
                    </div>
                    <Link to="/avis" className="inline-block mt-6 text-sm text-forest underline underline-offset-4" data-testid="back-to-avis">
                        Retourner à la page des avis
                    </Link>
                </div>
            </div>
        </main>
    );
}
